export const UserRegion = {
    BRASIL: "BRASIL",
    MEXICO: "MEXICO",
    CONOSUR: "CONOSUR",
    PACA: "PACA"
};


// WEBPACK FOOTER //
// ./src/helpers/enums/UserRegionEnum.js